/**
 * Réglages de la caméra du selfie d'un défi. Pur, testé.
 *
 * On demande la plus grande image NATIVE de la caméra avant (1920 × 1080),
 * jamais un simple rapport « 9:16 » : sans taille, le navigateur prenait sa
 * résolution par défaut (souvent 640 × 480) puis la RECADRAIT en 9:16 — image
 * zoomée et floue (≈ 360 × 640). Sur téléphone tenu droit, le flux arrive souvent
 * en portrait (1080 × 1920), mais pas toujours : rien n'est recadré, ni à l'écran ni dans la photo.
 */

export const SELFIE_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  facingMode: 'user',
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  frameRate: { ideal: 30, max: 30 },
};

/** Débit vidéo de l'enregistrement : 10 s ≈ 6 Mo, bien sous la limite de 50 Mo. */
export const SELFIE_VIDEO_BITS_PER_SECOND = 4_500_000;
export const SELFIE_AUDIO_BITS_PER_SECOND = 128_000;

export function selfieRecorderOptions(mimeType: string): MediaRecorderOptions {
  return {
    ...(mimeType ? { mimeType } : {}),
    videoBitsPerSecond: SELFIE_VIDEO_BITS_PER_SECOND,
    audioBitsPerSecond: SELFIE_AUDIO_BITS_PER_SECOND,
  };
}

/** Plus grand côté d'une photo de défi (pixels). */
export const SELFIE_PHOTO_MAX_SIDE = 1920;

export interface PhotoFrame {
  /** taille de la photo produite : l'image ENTIÈRE, au plus 1920 px de côté, jamais agrandie */
  width: number;
  height: number;
}

/**
 * Photo du selfie : l'image entière de la caméra, sans recadrage. Recadrer en 9:16 une image arrivée en
 * paysage (navigateurs qui ne tournent pas le flux) n'en gardait que le tiers central : visage zoomé.
 */
export function photoFrame(vw: number, vh: number): PhotoFrame {
  const scale = Math.min(1, SELFIE_PHOTO_MAX_SIDE / Math.max(vw, vh, 1));
  return {
    width: Math.max(1, Math.round(vw * scale)),
    height: Math.max(1, Math.round(vh * scale)),
  };
}
